import { lazy } from 'react'

export const AddingReleaseStep2Page = lazy(() => import('./AddingReleaseStep2Page'))
